<template>
  <div>
    <apex-charts
      type="bar"
      height="350"
      v-if="isChartDataReady"
      :options="chartOptions"
      :series="series"
      :toolbar="{ tools: { download: false } }"
    />
  </div>
</template>

<script>
import ApexCharts from "vue-apexcharts";

export default {
  components: {
    ApexCharts,
  },
  data() {
    const targets = {
      "Net Profit": 78,
      Students: 44,
      Leads: 52,
    };

    const achieved = [53, 32, 33];
    const pending = achieved.map((val, idx) => {
      const total = Object.values(targets)[idx];
      return Math.max(0, total - val);
    });

    return {
      isChartDataReady: true,
      series: [
        {
          name: "Achieved",
          data: achieved,
        },
        {
          name: "Pending",
          data: pending,
        },
      ],
      chartOptions: {
        chart: {
          type: "bar",
          height: 350,
          stacked: true,
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "55%",
            borderRadius: 0,
            dataLabels: {
              total: {
                enabled: true,
                offsetX: 0,
                style: {
                  fontSize: "13px",
                  fontWeight: 900,
                },
              },
            },
          },
        },
        stroke: {
          width: 1,
          colors: ["#333"],
        },
        xaxis: {
          categories: Object.keys(targets),
          labels: {
            formatter: function (val) {
              return `${val}\nTarget: ${targets[val]}`;
            },
          },
        },
        yaxis: {
          title: {
            text: "Values",
          },
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return val;
            },
          },
        },
        fill: {
          opacity: [1, 0],
        },
        legend: {
          position: "top",
          horizontalAlign: "left",
          offsetX: 40,
        },
        colors: ["#00E396", "#F5F5DC"],
      },
    };
  },
};
</script>
